<template>
    <pre class="tabs">
<b>This is a bass guitar tab***
    
Tuning: EADG (Standard Tuning)

x mute note
/ slide up
\ slide down

TAB:</b>

MAIN MELODY

G|-----7--x5-6x-7x------x5-6x-7x--------------------x5-6x-7x-----|
D|-----------------7-------------7---------------------------7---|
A|-3/5---------------5-------------5----------3----------------5-|
E|------------------------------------0-3-4-5---5----------------|

G|--x5-6x-7x-----------------------------------------7x----------|
D|-----------7---------------------------------------------------|
A|-------------5-------3-3------------3-3--------3/5-------------|
E|-----------------3/5-----5\3-1--3/5-----5\3-1------------------|

Tab Written By: WATERMELONE
    </pre>
</template>
<script>
export default {
    name: 'Beastly'
}
</script>
